<!-- <div class="inner-splash" [class.has-header-bar]="!inIframe"
    [class.hidden1]="(viewModelLoaded && !orchestratorViewModel.actionInProgress) || orchestratorViewModel.documentEnabled">
</div> -->
<div class="inner-splash" [class.has-header-bar]="skipHeader" [class.hidden]="!isVisible">
    <div *ngIf="animation" class="loader-animation" [class.has-loader-text]="text?.length > 0"></div>
</div>
<div [class.hidden]="!isVisible" [class.has-loader-animation]="animation" *ngIf="text?.length > 0" class="loader-text">
    {{text}}</div>
